import React from 'react'
import { useRouter } from 'next/router'

import { useAuth } from 'utils/auth'
import { useAPIGetProfileById } from 'api/profile/useAPIProfile'
import { IS_PROFILE_REVAMP_PHASE_THREE_ENABLED } from 'configs/toggle'

export const useProfile = () => {
  const router = useRouter()
  const { session } = useAuth()

  const profileId = decodeURI(
    (router.query.id ?? session?.user?.id ?? '') as string
  ).trim()
  const isCurrentUser = session?.user?.id === profileId

  const { data: profileResponse, status: profileFetchStatus } =
    useAPIGetProfileById(profileId)

  const profileData = React.useMemo(
    () => profileResponse?.data,
    [profileResponse?.data]
  )
  const isNarasumber = React.useMemo(
    () => profileData?.narasumber?.flag ?? false,
    [profileData?.narasumber?.flag]
  )
  const isNarasumberContactable =
    Boolean(profileData?.narasumber?.email) ||
    Boolean(profileData?.narasumber?.phone) ||
    Boolean(profileData?.narasumber?.whatsapp)

  // Section count
  const pelatihanMandiriBadgeCount =
    profileData?.pelatihanMandiri?.validatedTopic ?? 0
  const aksiNyataCount = (profileData?.pelatihanMandiri?.aksiNyata ?? []).length
  const buktiKaryaCount = (profileData?.buktiKarya ?? []).reduce(
    (acc, item) => acc + (item?.count ?? 0),
    0
  )
  const ceritaPraktikCount = (profileData?.ceritaPraktik ?? []).length
  const perangkatAjarCount = (profileData?.toolkits ?? []).reduce(
    (acc, item) => acc + (item?.count ?? 0),
    0
  )

  const hasCommunity =
    IS_PROFILE_REVAMP_PHASE_THREE_ENABLED &&
    Boolean(session) && // only for Logged-In users
    (profileData?.community ?? []).length > 0

  return {
    // Profile
    isCurrentUser,
    isNarasumber,
    isNarasumberContactable,
    profileId,
    profileData,
    profileFetchStatus,

    // Section count
    pelatihanMandiriBadgeCount,
    aksiNyataCount,
    buktiKaryaCount,
    ceritaPraktikCount,
    perangkatAjarCount,
    hasCommunity,
  }
}
